import React from "react";

export const Header = (props) => {
  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h1 className="fade-up">
                  {props.data ? props.data.title : "Loading"}
                </h1>
                <p className="fade-up delay-1">
                  {props.data ? props.data.paragraph : "Loading"}
                </p>
                <p className="fade-up delay-2">
                  {props.data ? props.data.supportingText1 : ""}
                </p>
                <p className="fade-up delay-3">
                  {props.data ? props.data.supportingText2 : ""}
                </p>
                <a
                  href="#transparent-section"
                  className="btn btn-custom btn-lg page-scroll fade-up delay-4"
                >
                  Get in Touch
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
